export type WhyChooseEmajinGolfItem = {
  id: string
  title: string
  caption: string
}

export const WHY_CHOOSE_EMAJIN_GOLF_ITEMS: WhyChooseEmajinGolfItem[] = [
  {
    id: 'WhyChooseEmajinGolfItem-001',
    title: 'Access',
    caption:
      'to play at some of the best golf courses and hidden gems across Australia',
  },
  {
    id: 'WhyChooseEmajinGolfItem-002',
    title: 'Learn',
    caption:
      'from senior executives as keynote speakers on relevant industry topics',
  },
  {
    id: 'WhyChooseEmajinGolfItem-003',
    title: 'Grow',
    caption:
      'your business network of senior business owners and c-suite executives Our events are exciting, innovative and fun!',
  },
]
